//
//
//
//
//
//
//
//
//
//
//
import automaticServerNew from "./automaticServerNew.vue";
import handleServer from "./handleServer.vue";
export default {
  name: "communication",
  components: {
    handleServer: handleServer,
    automaticServerNew: automaticServerNew
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'automaticServerNew'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};